export default __webpack_public_path__ + "static/media/t1Sala1.75a596d4.jpg";